// src/components/FloatingContact.js
import React, { useState, useEffect } from 'react';
import '../styles/FloatingContact.css';

// Create a context for the FloatingContact functionality
export const FloatingContactContext = React.createContext();

export const FloatingContactProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [countdown, setCountdown] = useState(3);
  const dubsadoFormUrl = "https://portal.dubsado.com/public/form/view/6697289e16c9b8003a062e6e";

  const handleToggle = () => {
    setIsOpen(!isOpen);

    // Reset state if closing
    if (isOpen) {
      setRedirecting(false);
    }
  };

  const handleOpenContact = () => {
    setIsOpen(true);
  };

  const handleRedirect = () => {
    setRedirecting(true);
    
    // Start countdown
    let count = 3;
    const timer = setInterval(() => {
      count -= 1;
      setCountdown(count);
      
      if (count <= 0) {
        clearInterval(timer);
        window.location.href = dubsadoFormUrl;
      }
    }, 1000);
  };

  const handleDirectRedirect = () => {
    window.location.href = dubsadoFormUrl;
  };

  return (
    <FloatingContactContext.Provider value={{ handleOpenContact }}>
      {children}
      <div className={`floating-contact ${isOpen ? 'open' : ''}`}>
        <button 
          className="contact-toggle" 
          onClick={handleToggle}
          aria-label={isOpen ? "Close contact form" : "Open contact form"}
        >
          {isOpen ? (
            <i className="fas fa-times"></i>
          ) : (
            <>
              <i className="fas fa-comment-alt"></i>
              <span>Contact Us</span>
            </>
          )}
        </button>

        <div className="contact-panel">
          <div className="contact-header">
            <h2>Get In Touch</h2>
            <p>Have questions? We're here to help!</p>
          </div>

          {redirecting ? (
            <div className="redirect-message">
              <i className="fas fa-sync fa-spin redirect-spinner"></i>
              <h3>Redirecting to our secure form...</h3>
              <p>You'll be redirected in {countdown} seconds</p>
              <div className="progress-bar">
                <div 
                  className="progress" 
                  style={{ width: `${((3 - countdown) / 3) * 100}%` }}
                ></div>
              </div>
              <p className="redirect-note">
                If you're not redirected automatically,{' '}
                <button onClick={handleDirectRedirect} className="text-button">
                  click here
                </button>
              </p>
            </div>
          ) : (
            <div className="contact-content">
              <div className="contact-intro">
                <p>
                  Let us know how we can help with your business formation and compliance needs.
                  Our team is ready to provide the support you need.
                </p>
              </div>
              
              <div className="contact-actions">
                <button onClick={handleRedirect} className="submit-btn contact-action-btn">
                  <i className="fas fa-paper-plane"></i> Contact Us Now
                </button>
                
                <div className="contact-divider">
                  <span>or</span>
                </div>
                
                <div className="contact-methods">
                  <div className="contact-method">
                    <i className="fas fa-phone"></i>
                    <span>(253) 802-4804</span>
                  </div>
                  <div className="contact-method">
                    <i className="fas fa-envelope"></i>
                    <span>legate@legatebusiness.com</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="contact-info">
            <div className="contact-method">
              <i className="fas fa-phone"></i>
              <span>(253) 802-4804</span>
            </div>
            <div className="contact-method">
              <i className="fas fa-envelope"></i>
              <span>legate@legatebusiness.com</span>
            </div>
            <div className="contact-method">
              <i className="fas fa-map-marker-alt"></i>
              <span>999 3rd St Suite #700, Seattle, WA 98104</span>
            </div>
          </div>
        </div>
      </div>
    </FloatingContactContext.Provider>
  );
};

const FloatingContact = () => {
  // This is just a placeholder component that will be used in places where we need
  // to include the FloatingContact component but don't want to render anything
  return null;
};

export default FloatingContact;
